import React from 'react';
import { BrowserRouter, Route, Switch} from 'react-router-dom'
import './assets-css/global.css'
import Whats from './components/whatsapp'
import Home from './pages/home'
import Treatments from './pages/treatments'
import About from './pages/about'
import Contact from './pages/contact'
import Facilities from './pages/facilities'
import ScrollTop from './components/ScrollTop'

/////// Pages treatments ///////

import endo from './pages/tra-pages/endo'
import cosmetic from './pages/tra-pages/cosmetic'
import perio from './pages/tra-pages/perio'
import orto from './pages/tra-pages/orto'
import surgery from './pages/tra-pages/surgery'
import implant from './pages/tra-pages/implant'
import { useTranslation , Trans} from 'react-i18next';



function App() {
  const { t } = useTranslation();
    window.scrollTo(0, 0);
  return (

    <BrowserRouter>
    <ScrollTop>
    <Switch>
    <Route exact path='/' component={Home}/>
    <Route path='/tratamientos' component={Treatments}/>
    <Route path='/Nosotros' component={About}/>
    <Route path='/Contacto' component={Contact}/>
    <Route path='/Instalaciones' component={Facilities}/>
    <Route path='/endodoncia' component={endo}/>
    <Route path='/estética-dental' component={cosmetic}/>
    <Route path='/ortodoncia' component={orto}/>
    <Route path='/cirugía-dental' component={surgery}/>
    <Route path='/periodoncia' component={perio}/>
    <Route path='/implantes-dentales' component={implant}/>
    </Switch>
    </ScrollTop> 
    </BrowserRouter>
  );
}

export default App;
